module.exports = "<div ng-if=\"ctrl.pageNotFound\" class=\"container\">\r\n  <br/>\r\n  <div class=\"alert alert-dismissible alert-warning\">\r\n    <i class=\"fa fa-fw fa-4x fa-meh-o\" style=\"float:left\"></i>\r\n    <h4>Oops! Page Not Found</h4>\r\n    <p>The page you are looking for is not (longer) available.</p>\r\n  </div>\r\n</div>\r\n\r\n<div ng-hide=\"ctrl.pageNotFound\" class=\"container\" bind-dynamic-page=\"ctrl.html\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/dynamic-page/dynamic-page.html
// module id = 322
// module chunks = 0